import { Injectable } from "@angular/core";
import { ApiService } from "../api/api.service";
import {
  Organization,
  OrganizationChatScope,
} from "../../interfaces/organization";
import { Observable } from "rxjs";
import { Guid } from "../../types/guid";

@Injectable({
  providedIn: "root",
})
export class OrganizationsService {
  constructor(private apiService: ApiService) {}

  getOrganizations(): Observable<Organization[]> {
    return this.apiService.getRequest<Organization[]>("orgadmin/organizations");
  }

  setRankingInOrganization(
    OrganizationId: Guid,
    in_ranking: boolean,
  ): Observable<boolean> {
    return this.apiService.putRequest<boolean>(
      `orgadmin/organizations/${OrganizationId}/in_ranking/`,
      { in_ranking },
    );
  }

  getChatSettings(
    OrganizationId: Guid,
  ): Observable<{ chat_scope: OrganizationChatScope }> {
    return this.apiService.getRequest<{ chat_scope: OrganizationChatScope }>(
      `orgadmin/organizations/${OrganizationId}/chat-settings/`,
    );
  }

  updateChatSettings(
    OrganizationId: Guid,
    chat_scope: OrganizationChatScope,
  ): Observable<{ chat_scope: OrganizationChatScope }> {
    return this.apiService.patchRequest<{ chat_scope: OrganizationChatScope }>(
      `orgadmin/organizations/${OrganizationId}/chat-settings/`,
      { chat_scope },
    );
  }
}
